import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import queryString from "query-string"
import NotificationAlert from "react-notification-alert"

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap"

import firebase from "firebaseConfig"

import AuthHeader from "components/Headers/AuthHeader.js"

class EmailActions extends React.Component {
  state = {
    email: "",
    password: "",
    reEnterPassword: "",
    isPasswordResetCodeValid: null,
    passwordsDontMatchError: null,
    validation: {},
    queryParams: {},
    emailVerified: null,
  }

  componentDidMount() {
    if (
      this.props &&
      this.props.location &&
      this.props.location.search &&
      this.props.location.search.length > 0
    ) {
      const queryParams = queryString.parse(this.props.location.search)
      this.setState({ queryParams })
      console.log(JSON.stringify(queryParams, null, 4))
      const { mode } = queryParams
      if (mode && mode === "resetPassword") {
        firebase
          .auth()
          .verifyPasswordResetCode(queryParams.oobCode)
          .then((email) => {
            // console.log('User Email', email);
            this.setState({
              email,
              isPasswordResetCodeValid: true,
            })
          })
          .catch((err) => {
            console.log(`An error occurred. Error:\n${err}`)
            this.setState({
              isPasswordResetCodeValid: false,
            })
          })
      } else if (mode && mode === "verifyEmail") {
        firebase
          .auth()
          .applyActionCode(queryParams.oobCode)
          .then((response) => {
            // console.log(response);
            console.log("Email Address Verified")
            this.setState({
              emailVerified: true,
            })
          })
          .catch((err) => {
            console.log(
              `Email Address Not Verified. An error occurred. Error:\n${err}`
            )
            this.setState({
              emailVerified: false,
            })
          })
      }
    }
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  onChange = (stateName, value) => {
    let stateValue = value
    let validation = { ...this.state.validation }
    if (stateName === "password" || stateName === "reEnterPassword") {
      validation[stateName] = "invalid"
      stateValue = stateValue.trim()
      if (stateValue.length >= 6) {
        validation[stateName] = "valid"
      }
    }
    this.setState({
      [stateName]: stateValue,
      validation,
    })
  }

  render() {
    const { queryParams } = this.state
    const { mode } = queryParams

    if (mode && mode === "resetPassword") {
      const {
        email,
        isPasswordResetCodeValid,
        passwordsDontMatchError,
      } = this.state

      return (
        <>
          <AuthHeader />
          <Container className="mt--8 pb-5">
            <Row className="justify-content-center">
              <div className="rna-wrapper">
                <NotificationAlert ref="notificationAlert" />
              </div>
              {isPasswordResetCodeValid === true ? (
                <Col lg="5" md="7">
                  <Card className="bg-secondary border-0 mb-0">
                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <h3>Reset Password</h3>
                        <small>
                          Please enter your new password for {email}.
                        </small>
                      </div>
                      <Form role="form">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="password"
                          >
                            Password
                          </label>
                          <Input
                            autoComplete="off"
                            id="password"
                            onChange={(e) =>
                              this.onChange("password", e.target.value)
                            }
                            placeholder="Password"
                            type="password"
                            valid={this.state.validation.password === "valid"}
                            invalid={
                              this.state.validation.password === "invalid"
                            }
                            value={this.state.password}
                          />
                          <div className="valid-feedback">Looks Good!</div>
                          <div className="invalid-feedback">
                            Password Must Be At Least 6 Characters
                          </div>
                        </FormGroup>
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="re-enter-password"
                          >
                            Re-Enter Password
                          </label>
                          <Input
                            autoComplete="off"
                            id="re-enter-password"
                            onChange={(e) =>
                              this.onChange("reEnterPassword", e.target.value)
                            }
                            placeholder="Password"
                            type="password"
                            valid={
                              this.state.validation.reEnterPassword === "valid"
                            }
                            invalid={
                              this.state.validation.reEnterPassword ===
                              "invalid"
                            }
                            value={this.state.reEnterPassword}
                          />
                          <div className="valid-feedback">Looks Good!</div>
                          <div className="invalid-feedback">
                            Password Must Be At Least 6 Characters
                          </div>
                        </FormGroup>
                        <div className="text-center">
                          <Button
                            className="my-4"
                            color="default"
                            type="button"
                            disabled={this.state.disableReset}
                            onClick={() => {
                              const { password, reEnterPassword } = this.state
                              if (password && reEnterPassword) {
                                if (password !== reEnterPassword) {
                                  this.setState({
                                    passwordsDontMatchError:
                                      "Passwords Do Not Match!",
                                  })
                                } else {
                                  // const { userExists, uid } = this.state;
                                  // console.log('Cloud Functions Call', userExists, uid);
                                  console.log("Password Reset")
                                  console.log(this.state.queryParams)
                                  this.setState({
                                    passwordsDontMatchError: null,
                                  })
                                  if (
                                    this.state.queryParams &&
                                    this.state.queryParams.oobCode
                                  ) {
                                    firebase
                                      .auth()
                                      .confirmPasswordReset(
                                        this.state.queryParams.oobCode,
                                        password
                                      )
                                      .then((response) => {
                                        console.log("Password Reset.")
                                        console.log(response)
                                        this.notify(
                                          "success",
                                          "Password Has Been Successfully Reset!",
                                          "Notification"
                                        )
                                        this.setState({
                                          disableReset: true,
                                        })
                                      })
                                      .catch((err) => {
                                        console.log(
                                          `Password Not Reset. Error:\n${err}`
                                        )
                                        this.notify(
                                          "success",
                                          "Password Has Been Already Reset Or The Link Is No Longer Valid",
                                          "Notification"
                                        )
                                        this.setState({
                                          disableReset: true,
                                        })
                                      })
                                  }
                                  // this.props.resetPassword(uid, password)
                                  //   .then(({ passwordReset }) => {
                                  //     if (passwordReset) {
                                  //       console.log('Password Reset');
                                  //     }
                                  //   })
                                  // Toast
                                }
                              }
                              // Toast
                            }}
                          >
                            Reset
                          </Button>
                          <span className="text-danger">
                            {passwordsDontMatchError ? (
                              <p>{passwordsDontMatchError}</p>
                            ) : null}
                          </span>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              ) : isPasswordResetCodeValid === false ? (
                <Col lg="5" md="7">
                  <br />
                  <br />
                  <Card>
                    <CardBody>
                      <CardTitle className="mb-3" tag="h3">
                        Notification
                      </CardTitle>
                      <CardText className="mb-4">
                        Password Has Been Reset Or The Link Is No Longer Valid.
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ) : null}
            </Row>
          </Container>
        </>
      )
    } else if (mode && mode === "verifyEmail") {
      const { emailVerified } = this.state

      return (
        <>
          <AuthHeader />
          <Container className="mt--8 pb-5">
            <br />
            <br />
            <Row className="justify-content-center">
              {emailVerified === true ? (
                <Card>
                  <CardBody>
                    <CardTitle className="mb-3" tag="h3">
                      Notification
                    </CardTitle>
                    <CardText className="mb-4">
                      Email Has Been Verified.
                    </CardText>
                  </CardBody>
                </Card>
              ) : emailVerified === false ? (
                <Card>
                  <CardBody>
                    <CardTitle className="mb-3" tag="h3">
                      Notification
                    </CardTitle>
                    <CardText className="mb-4">
                      Email Has Already Been Verified Or The Link Is No Longer
                      Valid.
                    </CardText>
                  </CardBody>
                </Card>
              ) : null}
            </Row>
          </Container>
        </>
      )
    }

    return null
  }
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EmailActions))
